export interface IComponentNodeDepsGroup {
    condition: 'AND' | 'OR';
    nodes: Array<IComponentNodeDepsGroup | IComponentNodeDepsRule>;
}

export const ComponentNodeDepsCond: Array<ComponentNodeDepsCondType> = [
    'exactly matches',
    'contains',
    'does not contain',
    'is in list',
    'is not in list',
    'does not equal',
    'starts with',
    'is empty',
    'is not empty',
];

export type ComponentNodeDepsCondType =
    | 'exactly matches'
    | 'contains'
    | 'does not contain'
    | 'is in list'
    | 'is not in list'
    | 'does not equal'
    | 'starts with'
    | 'is empty'
    | 'is not empty';

export interface IComponentNodeDepsRule {
    sourceType: 'state' | 'user';
    sourceValue: string;
    condition: ComponentNodeDepsCondType;
    compareParam1: string;
}

export type IComponentNodeDepsEffect = 'visibility';
export interface IComponentNodeDeps {
    effect: 'visibility';
    depsGroup: IComponentNodeDepsGroup;
}
